// pick nearest time around 10 min of targeted time
const NEAREST_TIME = 10 * 60 * 1000;

export const sleep = (ms) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

export const formatDuration = (value = 0, fullWord = false) => {
  const wordSrc = {
    d: 'Days',
    h: 'Hours',
    m: 'Minutes',
    s: 'Seconds',
  };

  const renderTimeProp = (key) => (!fullWord ? wordSrc?.[key]?.[0] : ['', wordSrc?.[key]].join(' '));
  if (value < 0) return '';

  const sec = parseInt(value, 10); // convert value to number if it's string
  const days = Math.floor(sec / 86400);
  const hours = Math.floor((sec % (3600 * 24)) / 3600);
  const minutes = Math.floor((sec % 3600) / 60);
  const seconds = Math.floor(sec % 60);

  return [
    `${days}${renderTimeProp('d')}`,
    `${hours}${renderTimeProp('h')}`,
    `${minutes}${renderTimeProp('m')}`,
    `${seconds}${renderTimeProp('s')}`,
  ]
    .filter((item) => item[0] !== '0')
    .join(' ');
};

export const processTimeLeft = (contractTimeLeft) => {
  const now = (Date.now() / 1000).toFixed(0);
  return contractTimeLeft - now;
};

const swapArrayElements = (arr, indexA, indexB) => {
  const temp = arr[indexA];
  arr[indexA] = arr[indexB];
  arr[indexB] = temp;
};

export const formatDateInput = (date = new Date()) => {
  const rawDate = date.toLocaleDateString();
  const splittedBySlash = rawDate.split('/').reverse();
  swapArrayElements(splittedBySlash, 1, 2);
  const _date = splittedBySlash.join('-');
  return _date;
};

export const getDay = (days) => {
  const dateOffset = 24 * 60 * 60 * 1000 * days;
  const currentDay = new Date();
  currentDay.setTime(currentDay.getTime() - dateOffset);
  return currentDay;
};

export const customDateFormat = (date = Date.now()) => {
  const rawDate = new Date(date);
  const parsedDayAndMonth = rawDate.toDateString();
  const [, parsedHour] = rawDate.toLocaleString().split(', ');
  // return [parsedDayAndMonth, parsedHour].join(' ');
  return {
    date: parsedDayAndMonth,
    time: parsedHour,
  };
};

export const createTimeStages = (now, creationDateTs, time, parse, length = 5) => {
  let timeStages =
    new Array(length)
      .fill(null)
      .map((timeStage, index) => ({
        date: new Date(now - time * 1000 * index),
        ts: new Date(now - time * 1000 * index).getTime(),
        formattedDate: parse(new Date(now - time * 1000 * index)),
      }))
      .reverse() || [];
  // minimum time stage date should be the creation date
  const firstDateAfterCreationIndex = timeStages.findIndex((timeStage) => timeStage.ts > creationDateTs);
  timeStages = timeStages.map((elem, index) => {
    if (index === firstDateAfterCreationIndex - 1) {
      elem = {
        date: new Date(creationDateTs),
        ts: creationDateTs,
        formattedDate: parse(new Date(creationDateTs)),
      };
      return elem;
    }
    return elem;
  });
  return timeStages;
};

export const findNearestTime = (time, targetTs, nearestTimeStandard = NEAREST_TIME) =>
  Math.abs(time - targetTs) < nearestTimeStandard;

const formatTime = (time = '') => {
  const [hours, mins] = time;
};

export const getDateTime = (_date) => {
  const date = new Date(_date);
  let [timeString] = date.toTimeString().split(' ');
  const [hour] = timeString.split(':');

  timeString = [hour, '00'].join(':');
  return timeString;
};

export const getDayAndMonth = (_date) => {
  const date = new Date(_date);
  const [dayAndMonth] = date.toLocaleString().split(',');
  const [month, day] = dayAndMonth.split('/');
  return [month, day].join('/');
};

export const getTimeOrDate = (dateInTs, needTime = false) => {
  const validatedDateInTs = dateInTs || Date.now();
  const today = Date.now();
  const isToday = today - new Date(validatedDateInTs).getTime() < 24 * 60 * 60 * 1000;

  const date = new Date(validatedDateInTs);

  let [fullTimeString] = date.toTimeString().split(' ');
  const [hour] = fullTimeString.split(':');

  fullTimeString = [hour, '00'].join(':');
  const [_date] = date.toLocaleString().split(',');

  return _date;
};
export const getTs = (date) => new Date(date).getTime();
